import React from "react";
import HR_Solutions from "../../Assets/img/Rectangle 1497.svg";
import {
  BsBriefcaseFill,
  BsCashCoin,
  BsBarChartLine,
  BsJournalRichtext,
  BsPeopleFill,
} from "react-icons/bs";
import { Link } from "react-router-dom";

const HrSolutions = () => {
  return (
    <>
      <div className="container Apply-padding" id="complete-hr-solutions">
        <div className="row align-items-center">
          <div className="col-md-4 mb-4 mb-md-0">
            <div
              className="position-relative rounded-4 reveal-left"
              style={{ backgroundColor: "transparent" }}
            >
              <img
                src={HR_Solutions}
                alt="HR Solutions"
                className="img-fluid w-100"
              />
              <Link to="/contact-us" className="btn-explore-link">
                <span className="btn-explore-service">Explore More</span>
              </Link>
            </div>
          </div>
          <div className="col-md-8 mb-4 mb-md-0">
            <div className="text-center mb-4 px-3 animate__animated animate__fadeInDown">
              <h2 className="section-title-service">
                <span className="highlight-number-service">04</span> Complete HR
                Solutions
              </h2>
              <p
                className="mt-3 fs-6 fw-normal mx-auto"
                style={{
                  maxWidth: "970px",
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#101011",
                }}
              >
                Anaxis offers Complete HR Solutions designed to support and
                optimize every aspect of your human resources functions. Beyond
                recruitment, we provide a full suite of services that empower
                your business to thrive.
              </p>
              <div className="row g-3">
                {/* HR Consulting */}
                <div className="col-sm-6">
                  <div className="hover-box">
                    <div className="icon-circle">
                      <BsBriefcaseFill size={24} />
                    </div>
                    <div>
                      <strong>HR Consulting</strong>
                      <p>
                        Strategic guidance to align HR practices with business
                        goals.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Payroll Management */}
                <div className="col-sm-6">
                  <div className="hover-box">
                    <div className="icon-circle">
                      <BsCashCoin size={24} />
                    </div>
                    <div>
                      <strong>Payroll Management</strong>
                      <p>
                        Timely payroll processing with full legal compliance.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Performance Management */}
                <div className="col-12 d-flex justify-content-center">
                  <div
                    className="hover-box"
                    style={{ maxWidth: "500px", width: "100%" }}
                  >
                    <div className="icon-circle">
                      <BsBarChartLine size={24} />
                    </div>
                    <div>
                      <strong>Performance Management</strong>
                      <p>
                        Process optimization for employee performance review and
                        growth.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Training & Development */}
                <div className="col-sm-6">
                  <div className="hover-box">
                    <div className="icon-circle">
                      <BsJournalRichtext size={24} />
                    </div>
                    <div>
                      <strong>Training & Development</strong>
                      <p>Upskill your team to adapt with business evolution.</p>
                    </div>
                  </div>
                </div>

                {/* Employee Relations */}
                <div className="col-sm-6">
                  <div className="hover-box">
                    <div className="icon-circle">
                      <BsPeopleFill size={24} />
                    </div>
                    <div>
                      <strong>Employee Relations</strong>
                      <p>
                        Improving communication, trust and workplace culture.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrSolutions;
